var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"main-footer d-flex p-2 px-3 bg-white border-top"},[_c('span',{staticClass:"copyright ml-auto my-auto mr-2"},[_vm._v("\n\t\tTodos los derechos reservados © "+_vm._s(_vm.year)+"\n\t")])])}
var staticRenderFns = []

export { render, staticRenderFns }